import { ActionType } from 'flow/store/engine/constants';

export const LOCAL_STORAGE_SNIPPET_KEY = 'snippetVersion' as const;

export const incompatibleGlobalSnippetActionTypes = [
  ActionType.SNIPPET,
  ActionType.OUTCOME_REASON,
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.OUTCOME,
];

export const incompatibleLocalSnippetActionTypes = [
  ActionType.SNIPPET,
  ActionType.OUTCOME,
];

export const externalSnippetActionTypes = [
  ActionType.INPUT,
  ActionType.OUTCOME_REASON,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.IMPORTED_MATRIX_MODEL,
];
